import { Coordinates } from '../types/catalog'

export interface ZipRecord {
  zip: string
  city: string
  coords: Coordinates
}

/**
 * ZIP-code centroids across the Puget Sound service area.
 * Used for instant offline lookup; full street addresses fall through
 * to the live geocoder in utils/geocode.ts.
 */
export const zipCentroids: ZipRecord[] = [
  // Seattle
  { zip: '98101', city: 'Seattle (Downtown)', coords: { lat: 47.6109, lng: -122.3352 } },
  { zip: '98102', city: 'Seattle (Eastlake)', coords: { lat: 47.6353, lng: -122.3222 } },
  { zip: '98103', city: 'Seattle (Fremont)', coords: { lat: 47.6736, lng: -122.3425 } },
  { zip: '98104', city: 'Seattle (Pioneer Sq)', coords: { lat: 47.6026, lng: -122.3284 } },
  { zip: '98105', city: 'Seattle (U District)', coords: { lat: 47.6614, lng: -122.301 } },
  { zip: '98106', city: 'Seattle (Delridge)', coords: { lat: 47.5333, lng: -122.3549 } },
  { zip: '98107', city: 'Seattle (Ballard)', coords: { lat: 47.6685, lng: -122.3765 } },
  { zip: '98108', city: 'Seattle (Georgetown)', coords: { lat: 47.5413, lng: -122.3115 } },
  { zip: '98109', city: 'Seattle (S Lake Union)', coords: { lat: 47.6317, lng: -122.3474 } },
  { zip: '98112', city: 'Seattle (Capitol Hill)', coords: { lat: 47.6314, lng: -122.2999 } },
  { zip: '98115', city: 'Seattle (Wedgwood)', coords: { lat: 47.6853, lng: -122.2874 } },
  { zip: '98116', city: 'Seattle (Alki)', coords: { lat: 47.5758, lng: -122.3904 } },
  { zip: '98117', city: 'Seattle (Crown Hill)', coords: { lat: 47.6889, lng: -122.3757 } },
  { zip: '98118', city: 'Seattle (Columbia City)', coords: { lat: 47.5423, lng: -122.2708 } },
  { zip: '98119', city: 'Seattle (Queen Anne)', coords: { lat: 47.6388, lng: -122.3696 } },
  { zip: '98122', city: 'Seattle (Central District)', coords: { lat: 47.6099, lng: -122.2977 } },
  { zip: '98125', city: 'Seattle (Lake City)', coords: { lat: 47.7166, lng: -122.3006 } },
  { zip: '98126', city: 'Seattle (West Seattle)', coords: { lat: 47.5474, lng: -122.3728 } },
  { zip: '98133', city: 'Seattle (Northgate)', coords: { lat: 47.7376, lng: -122.3436 } },
  { zip: '98136', city: 'Seattle (Fauntleroy)', coords: { lat: 47.5378, lng: -122.3873 } },
  { zip: '98144', city: 'Seattle (Mt Baker)', coords: { lat: 47.5859, lng: -122.2952 } },
  { zip: '98146', city: 'Seattle (White Center)', coords: { lat: 47.5008, lng: -122.3595 } },
  { zip: '98155', city: 'Shoreline (Lake Forest Pk)', coords: { lat: 47.7566, lng: -122.3015 } },
  { zip: '98168', city: 'Tukwila', coords: { lat: 47.4886, lng: -122.2982 } },
  { zip: '98177', city: 'Shoreline (Richmond Bch)', coords: { lat: 47.7413, lng: -122.372 } },
  { zip: '98178', city: 'Seattle (Skyway)', coords: { lat: 47.4977, lng: -122.2434 } },
  { zip: '98188', city: 'SeaTac', coords: { lat: 47.4473, lng: -122.2795 } },
  { zip: '98198', city: 'Des Moines', coords: { lat: 47.3897, lng: -122.3131 } },
  { zip: '98199', city: 'Seattle (Magnolia)', coords: { lat: 47.6478, lng: -122.4024 } },

  // North King / South Snohomish
  { zip: '98011', city: 'Bothell', coords: { lat: 47.7601, lng: -122.2054 } },
  { zip: '98012', city: 'Mill Creek', coords: { lat: 47.8548, lng: -122.2159 } },
  { zip: '98020', city: 'Edmonds', coords: { lat: 47.8107, lng: -122.3774 } },
  { zip: '98021', city: 'Bothell (Canyon Park)', coords: { lat: 47.7929, lng: -122.2201 } },
  { zip: '98026', city: 'Edmonds (Esperance)', coords: { lat: 47.8397, lng: -122.3311 } },
  { zip: '98028', city: 'Kenmore', coords: { lat: 47.7573, lng: -122.2443 } },
  { zip: '98033', city: 'Kirkland', coords: { lat: 47.6798, lng: -122.1892 } },
  { zip: '98034', city: 'Kirkland (Totem Lake)', coords: { lat: 47.7175, lng: -122.2029 } },
  { zip: '98036', city: 'Lynnwood', coords: { lat: 47.8209, lng: -122.2854 } },
  { zip: '98037', city: 'Lynnwood (Alderwood)', coords: { lat: 47.8419, lng: -122.2765 } },
  { zip: '98043', city: 'Mountlake Terrace', coords: { lat: 47.7923, lng: -122.3087 } },
  { zip: '98072', city: 'Woodinville', coords: { lat: 47.7717, lng: -122.1443 } },
  { zip: '98077', city: 'Woodinville (Hollywood)', coords: { lat: 47.7466, lng: -122.0836 } },
  { zip: '98087', city: 'Lynnwood (Silver Firs)', coords: { lat: 47.8698, lng: -122.2455 } },
  { zip: '98201', city: 'Everett', coords: { lat: 47.9789, lng: -122.2021 } },
  { zip: '98203', city: 'Everett (South)', coords: { lat: 47.9445, lng: -122.2246 } },
  { zip: '98204', city: 'Everett (Casino Rd)', coords: { lat: 47.9, lng: -122.246 } },
  { zip: '98208', city: 'Everett (Silver Lake)', coords: { lat: 47.9, lng: -122.1907 } },
  { zip: '98012-mc', city: 'Mill Creek', coords: { lat: 47.8601, lng: -122.2043 } },
  { zip: '98270', city: 'Marysville', coords: { lat: 48.0665, lng: -122.1571 } },
  { zip: '98271', city: 'Marysville (Smokey Pt)', coords: { lat: 48.1168, lng: -122.1846 } },
  { zip: '98275', city: 'Mukilteo', coords: { lat: 47.9107, lng: -122.3021 } },
  { zip: '98290', city: 'Snohomish', coords: { lat: 47.9265, lng: -122.0871 } },
  { zip: '98296', city: 'Snohomish (Maltby)', coords: { lat: 47.8459, lng: -122.1078 } },
  { zip: '98258', city: 'Lake Stevens', coords: { lat: 48.0146, lng: -122.0637 } },
  { zip: '98272', city: 'Monroe', coords: { lat: 47.8554, lng: -121.9709 } },

  // Eastside
  { zip: '98004', city: 'Bellevue (West)', coords: { lat: 47.6187, lng: -122.2016 } },
  { zip: '98005', city: 'Bellevue (Crossroads)', coords: { lat: 47.6152, lng: -122.1673 } },
  { zip: '98006', city: 'Bellevue (Newcastle)', coords: { lat: 47.5561, lng: -122.1533 } },
  { zip: '98007', city: 'Bellevue (Northeast)', coords: { lat: 47.6144, lng: -122.1414 } },
  { zip: '98008', city: 'Bellevue (Lake Hills)', coords: { lat: 47.6062, lng: -122.1156 } },
  { zip: '98027', city: 'Issaquah', coords: { lat: 47.5301, lng: -122.0326 } },
  { zip: '98029', city: 'Issaquah (Highlands)', coords: { lat: 47.5533, lng: -122.0058 } },
  { zip: '98040', city: 'Mercer Island', coords: { lat: 47.5707, lng: -122.2221 } },
  { zip: '98052', city: 'Redmond', coords: { lat: 47.674, lng: -122.1215 } },
  { zip: '98053', city: 'Redmond (Union Hill)', coords: { lat: 47.6606, lng: -122.0243 } },
  { zip: '98074', city: 'Sammamish', coords: { lat: 47.6163, lng: -122.0439 } },
  { zip: '98075', city: 'Sammamish (Pine Lake)', coords: { lat: 47.5852, lng: -122.0316 } },
  { zip: '98059', city: 'Renton (Highlands)', coords: { lat: 47.4886, lng: -122.1284 } },
  { zip: '98065', city: 'Snoqualmie', coords: { lat: 47.5287, lng: -121.8254 } },
  { zip: '98045', city: 'North Bend', coords: { lat: 47.4957, lng: -121.7866 } },
  { zip: '98014', city: 'Carnation', coords: { lat: 47.6487, lng: -121.9107 } },
  { zip: '98019', city: 'Duvall', coords: { lat: 47.7423, lng: -121.9857 } },

  // South King
  { zip: '98002', city: 'Auburn', coords: { lat: 47.3073, lng: -122.2168 } },
  { zip: '98003', city: 'Federal Way', coords: { lat: 47.3067, lng: -122.3245 } },
  { zip: '98023', city: 'Federal Way (West)', coords: { lat: 47.3081, lng: -122.3623 } },
  { zip: '98030', city: 'Kent (East Hill)', coords: { lat: 47.3785, lng: -122.2018 } },
  { zip: '98031', city: 'Kent (Panther Lake)', coords: { lat: 47.4022, lng: -122.1957 } },
  { zip: '98032', city: 'Kent (Valley)', coords: { lat: 47.3897, lng: -122.2596 } },
  { zip: '98042', city: 'Covington', coords: { lat: 47.3573, lng: -122.1218 } },
  { zip: '98047', city: 'Pacific', coords: { lat: 47.2637, lng: -122.2493 } },
  { zip: '98055', city: 'Renton (South)', coords: { lat: 47.4571, lng: -122.2065 } },
  { zip: '98056', city: 'Renton (Kennydale)', coords: { lat: 47.5119, lng: -122.1866 } },
  { zip: '98057', city: 'Renton (Downtown)', coords: { lat: 47.4732, lng: -122.2172 } },
  { zip: '98058', city: 'Renton (Fairwood)', coords: { lat: 47.4402, lng: -122.1433 } },
  { zip: '98038', city: 'Maple Valley', coords: { lat: 47.3673, lng: -122.0448 } },
  { zip: '98051', city: 'Ravensdale', coords: { lat: 47.3596, lng: -121.9765 } },
  { zip: '98010', city: 'Black Diamond', coords: { lat: 47.3087, lng: -122.0043 } },
  { zip: '98022', city: 'Enumclaw', coords: { lat: 47.2043, lng: -121.9915 } },
  { zip: '98092', city: 'Auburn (Lea Hill)', coords: { lat: 47.2854, lng: -122.1487 } },
  { zip: '98148', city: 'Burien (Seahurst)', coords: { lat: 47.4437, lng: -122.3258 } },
  { zip: '98166', city: 'Burien', coords: { lat: 47.4704, lng: -122.3468 } },
  { zip: '98070', city: 'Vashon', coords: { lat: 47.4115, lng: -122.4646 } },

  // Pierce
  { zip: '98327', city: 'DuPont', coords: { lat: 47.0979, lng: -122.6318 } },
  { zip: '98338', city: 'Graham', coords: { lat: 47.0518, lng: -122.2943 } },
  { zip: '98360', city: 'Orting', coords: { lat: 47.0968, lng: -122.2043 } },
  { zip: '98371', city: 'Puyallup', coords: { lat: 47.1854, lng: -122.2929 } },
  { zip: '98372', city: 'Puyallup (East)', coords: { lat: 47.2043, lng: -122.2632 } },
  { zip: '98374', city: 'Puyallup (South Hill)', coords: { lat: 47.1352, lng: -122.2846 } },
  { zip: '98375', city: 'Spanaway', coords: { lat: 47.0968, lng: -122.3381 } },
  { zip: '98390', city: 'Sumner', coords: { lat: 47.2032, lng: -122.2401 } },
  { zip: '98391', city: 'Bonney Lake', coords: { lat: 47.1774, lng: -122.1868 } },
  { zip: '98387', city: 'Spanaway (Roy)', coords: { lat: 47.0576, lng: -122.4001 } },
  { zip: '98402', city: 'Tacoma (Downtown)', coords: { lat: 47.2529, lng: -122.4443 } },
  { zip: '98404', city: 'Tacoma (East)', coords: { lat: 47.2185, lng: -122.4045 } },
  { zip: '98405', city: 'Tacoma (Central)', coords: { lat: 47.2513, lng: -122.4746 } },
  { zip: '98406', city: 'Tacoma (West End)', coords: { lat: 47.261, lng: -122.5055 } },
  { zip: '98408', city: 'Tacoma (South)', coords: { lat: 47.1927, lng: -122.4416 } },
  { zip: '98409', city: 'Tacoma (Lakewood N)', coords: { lat: 47.2123, lng: -122.4785 } },
  { zip: '98422', city: 'Tacoma (Browns Pt)', coords: { lat: 47.2966, lng: -122.3869 } },
  { zip: '98424', city: 'Fife', coords: { lat: 47.2334, lng: -122.3567 } },
  { zip: '98444', city: 'Parkland', coords: { lat: 47.1462, lng: -122.4351 } },
  { zip: '98446', city: 'Tacoma (Midland)', coords: { lat: 47.1442, lng: -122.3893 } },
  { zip: '98499', city: 'Lakewood', coords: { lat: 47.1662, lng: -122.5018 } },

  // Kitsap
  { zip: '98110', city: 'Bainbridge Island', coords: { lat: 47.6262, lng: -122.5212 } },
  { zip: '98310', city: 'Bremerton', coords: { lat: 47.5851, lng: -122.6213 } },
  { zip: '98312', city: 'Bremerton (West)', coords: { lat: 47.5673, lng: -122.7171 } },
  { zip: '98337', city: 'Bremerton (Downtown)', coords: { lat: 47.5647, lng: -122.6303 } },
  { zip: '98366', city: 'Port Orchard', coords: { lat: 47.5407, lng: -122.6098 } },
  { zip: '98370', city: 'Poulsbo', coords: { lat: 47.7376, lng: -122.6432 } },
  { zip: '98383', city: 'Silverdale', coords: { lat: 47.6448, lng: -122.6952 } },
  { zip: '98392', city: 'Suquamish', coords: { lat: 47.7315, lng: -122.5545 } },
]
